import { AfterViewInit, Component, ComponentRef, Injector, ViewChild, ViewContainerRef, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveDirective } from '@any2any/shared';
import { Modal } from '../modal';
import { ModalService } from '../modal.service';

@Component({
    selector: 'app-modal-container',
    templateUrl: './modal-container.component.html',
    styleUrls: ['./modal-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ModalContainerComponent extends ReactiveDirective implements AfterViewInit {

  public renderedModals: Modal.Init[] = [];

  @ViewChild('entrypoint', { read: ViewContainerRef }) private viewContainerRef!: ViewContainerRef;
  private readonly componentRefs = new Map<Modal.Init, ComponentRef<unknown>>();

  private readonly modalService = inject(ModalService);
  private readonly injector = inject(Injector);

  public ngAfterViewInit(): void {
    this.observeModalsStack();
  }

  private observeModalsStack(): void {
    this.modalService.modalsStack()
      .pipe(this.observeUntilDestroy())
      .subscribe(stack => {
        if (stack.length > this.renderedModals.length) {
          this.handleModalPush(stack);
        } else if (stack.length < this.renderedModals.length) {
          this.handleModalPop();
        }
        this.renderedModals = stack.slice();
      });
  }

  private handleModalPush(newStack: Modal.Init[]): void {
    const newModal = newStack[newStack.length - 1];
    const componentRef = this.viewContainerRef.createComponent(newModal.component, {
      injector: this.prepareInjectorWithModalRef(newModal)
    });
    componentRef.changeDetectorRef.detectChanges();
    this.componentRefs.set(newModal, componentRef);
  }

  private handleModalPop(): void {
    const topModal = this.renderedModals[this.renderedModals.length - 1];
    const componentRef = this.componentRefs.get(topModal);
    if (!componentRef) {
      return;
    }
    componentRef.destroy();
    this.componentRefs.delete(topModal);
  }

  private prepareInjectorWithModalRef(modal: Modal.Init): Injector {
    const modalRef: Modal.Ref = {
      data: modal.data,
      close: result => {
        modal.callback(result);
      }
    };
    return Injector.create({
      providers: [{
        provide: Modal.REF,
        useValue: modalRef
      }],
      parent: this.injector
    });
  }

}
